import { apiFetch } from '@/api/client'

export const questionnairesApi = {
  formTypes: (workspaceId) => apiFetch(`workspaces/${workspaceId}/workspace-forms/types`),
  templates: (type, params) => apiFetch(`form-templates/${type}`, { params }),
  workspaceForms: (workspaceId, type, params) =>
    apiFetch(`workspaces/${workspaceId}/workspace-forms/${type}`, { params }),
  updateTemplates: (type, payload) =>
    apiFetch(`form-templates/${type}`, { method: 'PUT', body: payload }),
  // Laravel method spoofing, kept as the backend expects it.
  updateWorkspaceForms: (workspaceId, type, payload) =>
    apiFetch(`workspaces/${workspaceId}/workspace-forms/${type}`, {
      method: 'POST',
      body: { ...payload, _method: 'PUT' },
    }),
  questionBank: (params) => apiFetch('global-questions/workspace', { params }),
}
